type AnswerOptionsProps = {
  options: string[];
  correctAnswer: string;
  selectedAnswer: string | null;
  hasAnsweredCorrect: boolean;
  disabled: boolean;
  onSelect: (answer: string) => void;
};

export function AnswerOptions({
  options,
  correctAnswer,
  selectedAnswer,
  hasAnsweredCorrect,
  disabled,
  onSelect,
}: AnswerOptionsProps) {
  return (
    <div className="rr-answer-grid" role="group" aria-label="Answer choices">
      {options.map((option) => {
        const isSelected = selectedAnswer === option;
        const isCorrect = option === correctAnswer;
        const stateClass = hasAnsweredCorrect && isCorrect
          ? ' rr-answer-correct'
          : isSelected
            ? ' rr-answer-try-again'
            : '';

        return (
          <button
            key={option}
            type="button"
            className={`rr-answer-button${stateClass}`}
            onClick={() => onSelect(option)}
            disabled={disabled || hasAnsweredCorrect}
            aria-pressed={isSelected}
          >
            {option}
          </button>
        );
      })}
    </div>
  );
}
